@let items = (workerStatuses$ | async) ?? [];

<lib-multiselect
  titleTranslationKey="monitoring.worker-status"
  chosenTranslationKey="monitoring.worker-statuses-chosen"
  [options]="items"
  [formControl]="controlEntity"
/>
